(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5778],{

/***/ 19494:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/non-benefit/map",
      function () {
        return __webpack_require__(38139);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81541);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22522);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64952);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78287);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CustomBreadCrumbs = function(param) {
    var visible = param.visible, breadCrumbs = param.breadCrumbs;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    var breadCrumbsWithHome = [
        {
            label: "홈",
            url: "/",
            logName: "home"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(breadCrumbs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumbsWithHome.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumbsWithHome.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomBreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aeec3b7-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_10__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aeec3b7-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aeec3b7-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
CustomBreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 2721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var Link = function(param) {
    var _hasWrapper = param.hasWrapper, hasWrapper = _hasWrapper === void 0 ? true : _hasWrapper;
    if (hasWrapper) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "16",
                    fill: "#DFE1E2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    clipPath: "url(#clip0_187_4288)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M19.5458 8.00944C19.1947 8.0585 18.8648 8.20877 18.5967 8.4418C18.5587 8.47482 17.9873 9.04759 17.3268 9.71463C16.6664 10.3817 15.8477 11.2082 15.5076 11.5514C15.0912 11.9715 14.8781 12.1911 14.8553 12.2234C14.7984 12.3041 14.7632 12.3831 14.7383 12.4858C14.725 12.5409 14.7269 12.7264 14.7414 12.7883C14.7857 12.9771 14.9043 13.1363 15.0787 13.2411C15.1368 13.276 15.1781 13.293 15.2546 13.3134C15.2983 13.3251 15.3236 13.3271 15.4274 13.3272C15.5407 13.3273 15.5533 13.3261 15.613 13.3096C15.6929 13.2875 15.7767 13.2463 15.844 13.196C15.8794 13.1695 16.4653 12.5823 17.7064 11.3294C18.7022 10.324 19.5315 9.49052 19.5492 9.47714C19.6175 9.42552 19.6965 9.40048 19.7922 9.40013C19.8869 9.39978 19.9553 9.41897 20.0248 9.46542C20.0495 9.48188 20.4235 9.85676 21.1084 10.5514C22.6644 12.1296 22.49 11.9488 22.524 12.0193C22.5565 12.0868 22.5666 12.1313 22.5666 12.2076C22.5666 12.2727 22.549 12.3435 22.5177 12.4046C22.4954 12.4481 22.3941 12.5508 20.656 14.2906C19.0524 15.8959 18.8135 16.1376 18.7826 16.185C18.7391 16.2519 18.7195 16.291 18.7024 16.345C18.6753 16.4307 18.6722 16.4546 18.6724 16.5754C18.6726 16.6755 18.6747 16.7018 18.6862 16.745C18.7065 16.8213 18.7236 16.8628 18.7585 16.9209C18.8634 17.0954 19.0225 17.2139 19.2114 17.2582C19.25 17.2673 19.2857 17.2697 19.373 17.2693C19.4731 17.2688 19.4918 17.267 19.549 17.2517C19.6244 17.2316 19.7003 17.1965 19.7686 17.1504C19.8071 17.1243 20.202 16.7332 21.5928 15.3439C22.5691 14.3686 23.4076 13.5283 23.4561 13.4765C23.5582 13.3675 23.6081 13.3053 23.6755 13.2026C23.7995 13.0141 23.8908 12.7922 23.9356 12.5709C23.964 12.4304 23.9712 12.3567 23.9712 12.2042C23.9712 12.0518 23.964 11.9781 23.9356 11.8375C23.8775 11.5505 23.7472 11.2775 23.5576 11.0453C23.5253 11.0058 23.297 10.7687 23.0501 10.5185C22.8032 10.2682 22.2652 9.72215 21.8545 9.30503C21.4438 8.88791 21.0739 8.51544 21.0324 8.47733C20.752 8.21971 20.4091 8.05847 20.0358 8.00876C19.9457 7.99676 19.6334 7.99719 19.5458 8.00944ZM18.1666 13.0562C18.0995 13.0626 18.0112 13.0863 17.9525 13.1136C17.8344 13.1685 17.9689 13.0373 15.5035 15.5027C13.0379 17.9682 13.1691 17.8337 13.1143 17.9517C13.0386 18.1149 13.0334 18.3373 13.1014 18.5071C13.1696 18.6773 13.3223 18.83 13.4926 18.8982C13.6623 18.9662 13.8847 18.961 14.0479 18.8853C14.1659 18.8305 14.0314 18.9617 16.4969 16.4962C18.9625 14.0306 18.8312 14.1651 18.886 14.0471C18.9615 13.8844 18.9668 13.6611 18.899 13.4918C18.8436 13.3535 18.7321 13.2256 18.5951 13.1433C18.4791 13.0737 18.3206 13.0414 18.1666 13.0562ZM12.5378 14.7295C12.4066 14.752 12.3215 14.7859 12.2242 14.8545C12.1919 14.8773 11.9722 15.0905 11.5522 15.5068C11.209 15.847 10.3824 16.6657 9.71538 17.3261C9.04834 17.9865 8.47557 18.558 8.44255 18.596C8.20667 18.8674 8.05682 19.199 8.00951 19.5542C7.99683 19.6494 7.99683 19.9399 8.00951 20.035C8.05773 20.3971 8.21085 20.7307 8.45672 21.0095C8.55327 21.1189 10.9877 23.5456 11.053 23.5975C11.3264 23.8146 11.6305 23.9456 11.9646 23.9901C12.0598 24.0028 12.3502 24.0028 12.4454 23.9901C12.8169 23.9406 13.1621 23.7791 13.4389 23.525C13.4787 23.4885 14.0387 22.9258 14.6833 22.2746C15.3279 21.6234 16.1391 20.8041 16.4861 20.4538C16.9475 19.9881 17.126 19.8038 17.1507 19.7678C17.1969 19.7004 17.2321 19.6243 17.2525 19.5482C17.2677 19.491 17.2696 19.4723 17.2701 19.3722C17.2705 19.285 17.268 19.2493 17.2589 19.2106C17.2146 19.0217 17.0961 18.8626 16.9216 18.7577C16.8636 18.7229 16.8223 18.7059 16.7458 18.6854C16.7021 18.6737 16.6768 18.6717 16.573 18.6716C16.4595 18.6715 16.4471 18.6727 16.3874 18.6893C16.3061 18.7119 16.2225 18.7529 16.1563 18.8027C16.1213 18.829 15.5146 19.4371 14.2918 20.6716C13.2949 21.678 12.4653 22.5116 12.4484 22.5241C12.3789 22.5751 12.3022 22.5986 12.205 22.5986C12.1264 22.5986 12.081 22.5883 12.013 22.5551C11.9661 22.5323 11.9357 22.5024 10.7164 21.2832C9.49722 20.064 9.46735 20.0335 9.4445 19.9866C9.41133 19.9186 9.40106 19.8732 9.40106 19.7946C9.40106 19.6958 9.42539 19.6179 9.47791 19.5484C9.49129 19.5307 10.3248 18.7014 11.3302 17.7056C12.5825 16.4651 13.1703 15.8786 13.1968 15.8432C13.247 15.776 13.2883 15.6922 13.3104 15.6122C13.3269 15.5526 13.3281 15.54 13.328 15.4266C13.3279 15.3229 13.3259 15.2975 13.3142 15.2538C13.2938 15.1774 13.2768 15.136 13.2419 15.078C13.1382 14.9055 12.9811 14.7875 12.7938 14.7415C12.7538 14.7316 12.5743 14.7233 12.5378 14.7295Z",
                        fill: "#3D4551"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_187_4288",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white",
                            transform: "translate(8 8)"
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_403_8651)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.5458 0.00943519C11.1947 0.0584976 10.8648 0.20877 10.5967 0.4418C10.5587 0.474818 9.98728 1.04759 9.32685 1.71463C8.6664 2.38167 7.84774 3.20823 7.50758 3.55143C7.09124 3.9715 6.87805 4.19112 6.85526 4.22343C6.79836 4.3041 6.76318 4.38305 6.73834 4.48583C6.72501 4.54093 6.72691 4.72638 6.74143 4.78826C6.78574 4.97713 6.90426 5.13626 7.07874 5.24113C7.13678 5.27601 7.17811 5.29301 7.25458 5.31345C7.29828 5.32512 7.32361 5.32714 7.42738 5.32723C7.5407 5.32732 7.55334 5.32613 7.61298 5.30962C7.69294 5.2875 7.77675 5.24629 7.84396 5.19604C7.87945 5.16951 8.46528 4.58234 9.70636 3.3294C10.7022 2.32405 11.5315 1.49052 11.5492 1.47714C11.6175 1.42552 11.6965 1.40048 11.7922 1.40013C11.8869 1.39978 11.9553 1.41897 12.0248 1.46542C12.0495 1.48188 12.4235 1.85676 13.1084 2.55139C14.6644 4.12964 14.49 3.9488 14.524 4.01933C14.5565 4.08678 14.5666 4.13127 14.5666 4.20759C14.5666 4.27274 14.549 4.34346 14.5177 4.40455C14.4954 4.44812 14.3941 4.55078 12.656 6.29063C11.0524 7.89592 10.8135 8.13757 10.7826 8.18503C10.7391 8.25189 10.7195 8.29103 10.7024 8.34503C10.6753 8.43074 10.6722 8.45459 10.6724 8.57543C10.6726 8.67551 10.6747 8.70175 10.6862 8.74503C10.7065 8.82134 10.7236 8.86276 10.7585 8.92087C10.8634 9.09536 11.0225 9.21388 11.2114 9.25819C11.25 9.26726 11.2857 9.26972 11.373 9.26931C11.4731 9.26884 11.4918 9.26697 11.549 9.2517C11.6244 9.23159 11.7003 9.19653 11.7686 9.15036C11.8071 9.1243 12.202 8.73324 13.5928 7.34387C14.5691 6.36859 15.4076 5.52826 15.4561 5.47646C15.5582 5.36753 15.6081 5.30529 15.6755 5.20263C15.7995 5.01407 15.8908 4.79223 15.9356 4.57094C15.964 4.43041 15.9712 4.35669 15.9712 4.20423C15.9712 4.05178 15.964 3.97806 15.9356 3.83752C15.8775 3.55055 15.7472 3.27749 15.5576 3.04533C15.5253 3.00583 15.297 2.76874 15.0501 2.51847C14.8032 2.2682 14.2652 1.72215 13.8545 1.30503C13.4438 0.887912 13.0739 0.515445 13.0324 0.477326C12.752 0.219714 12.4091 0.058472 12.0358 0.00875679C11.9457 -0.00324321 11.6334 -0.00280801 11.5458 0.00943519ZM10.1666 5.05617C10.0995 5.06259 10.0112 5.08627 9.9525 5.11356C9.83439 5.16848 9.96887 5.03729 7.50346 7.50271C5.03792 9.96824 5.16913 9.83374 5.11435 9.95175C5.0386 10.1149 5.03341 10.3373 5.10139 10.5071C5.16957 10.6773 5.32228 10.83 5.49256 10.8982C5.66232 10.9662 5.88471 10.961 6.04787 10.8853C6.16587 10.8305 6.03137 10.9617 8.49691 8.49615C10.9625 6.03062 10.8312 6.16512 10.886 6.04712C10.9615 5.88443 10.9668 5.66108 10.899 5.49181C10.8436 5.35347 10.7321 5.22559 10.5951 5.14333C10.4791 5.07367 10.3206 5.04143 10.1666 5.05617ZM4.53778 6.72951C4.40655 6.75196 4.3215 6.78586 4.22418 6.85451C4.19187 6.8773 3.97225 7.09049 3.55218 7.50683C3.20898 7.84699 2.38242 8.66565 1.71538 9.32609C1.04834 9.98653 0.47557 10.558 0.442552 10.596C0.206674 10.8674 0.056824 11.199 0.0095088 11.5542C-0.0031696 11.6494 -0.0031696 11.9399 0.0095088 12.035C0.0577264 12.3971 0.210846 12.7307 0.456715 13.0095C0.553266 13.1189 2.98765 15.5456 3.05298 15.5975C3.32635 15.8146 3.63046 15.9456 3.96457 15.9901C4.05975 16.0028 4.35021 16.0028 4.44539 15.9901C4.81694 15.9406 5.16205 15.7791 5.43894 15.525C5.47873 15.4885 6.03868 14.9258 6.68327 14.2746C7.32785 13.6234 8.13913 12.8041 8.48611 12.4538C8.94747 11.9881 9.12604 11.8038 9.15068 11.7678C9.19689 11.7004 9.23215 11.6243 9.25245 11.5482C9.26772 11.491 9.26959 11.4723 9.27006 11.3722C9.27047 11.285 9.26801 11.2493 9.25894 11.2106C9.21463 11.0217 9.09611 10.8626 8.92162 10.7577C8.86359 10.7229 8.82226 10.7059 8.74578 10.6854C8.70209 10.6737 8.67676 10.6717 8.57298 10.6716C8.45953 10.6715 8.4471 10.6727 8.38738 10.6893C8.30606 10.7119 8.22246 10.7529 8.15631 10.8027C8.1213 10.829 7.51458 11.4371 6.29181 12.6716C5.29488 13.678 4.46534 14.5116 4.44838 14.5241C4.37889 14.5751 4.30222 14.5986 4.20498 14.5986C4.12642 14.5986 4.08101 14.5883 4.01298 14.5551C3.96611 14.5323 3.93566 14.5024 2.71644 13.2832C1.49722 12.064 1.46735 12.0335 1.4445 11.9866C1.41133 11.9186 1.40106 11.8732 1.40106 11.7946C1.40106 11.6958 1.42539 11.6179 1.47791 11.5484C1.49129 11.5307 2.32482 10.7014 3.33019 9.70558C4.58253 8.46508 5.1703 7.87864 5.19681 7.84318C5.24704 7.776 5.28825 7.69217 5.31037 7.61223C5.32688 7.55259 5.32807 7.53995 5.32798 7.42663C5.3279 7.32286 5.32587 7.29752 5.3142 7.25383C5.29376 7.17736 5.27676 7.13603 5.24188 7.07799C5.1382 6.90548 4.98114 6.78753 4.79378 6.74148C4.75379 6.73165 4.57433 6.72326 4.53778 6.72951Z",
                    fill: "#3D4551"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_403_8651",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 22701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ KAKAO_SHARE_TYPE; },
  "C": function() { return /* binding */ SelectModal_ShareSelectModal; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(81541);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(72282);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/components/atom/icon/Kakao.tsx

var KakaoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#FFE337"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6719 10C14.7552 10 13.8906 10.1406 13.0781 10.4219C12.2656 10.7031 11.5573 11.0833 10.9531 11.5625C10.349 12.0417 9.86979 12.6042 9.51562 13.25C9.17188 13.8958 9 14.5833 9 15.3125C9 15.7812 9.07292 16.2344 9.21875 16.6719C9.36458 17.099 9.56771 17.5052 9.82812 17.8906C10.099 18.2656 10.4219 18.6146 10.7969 18.9375C11.1719 19.25 11.5833 19.526 12.0312 19.7656L11.5312 22.375L14.4219 20.5312C14.6198 20.5625 14.8229 20.5885 15.0312 20.6094C15.2396 20.6198 15.4531 20.625 15.6719 20.625C16.5885 20.625 17.4531 20.4896 18.2656 20.2188C19.0781 19.9375 19.7865 19.5573 20.3906 19.0781C20.9948 18.5885 21.4688 18.026 21.8125 17.3906C22.1667 16.7448 22.3438 16.0521 22.3438 15.3125C22.3438 14.5833 22.1667 13.8958 21.8125 13.25C21.4688 12.6042 20.9948 12.0417 20.3906 11.5625C19.7865 11.0833 19.0781 10.7031 18.2656 10.4219C17.4531 10.1406 16.5885 10 15.6719 10Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Kakao = (KakaoIcon);

// EXTERNAL MODULE: ./src/components/atom/icon/Link.tsx
var Link = __webpack_require__(2721);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/index.tsx
var SelectModal = __webpack_require__(73451);
;// CONCATENATED MODULE: ./src/components/molecules/Modal/SelectModal/ShareSelectModal/index.tsx










var KAKAO_SHARE_TYPE = {
    QNA: "QNA",
    MAGAZINE: "MAGAZINE",
    BOARD_POST: "BOARD_POST",
    NON_BENEFIT_MAP: "NON_BENEFIT_MAP"
};
/**
 * @param isVisible boolean
 * @param onClose () => void
 * @param type KAKAO_SHARE_TYPE
 * @param pageName string
 * @param kakaoShare [optional] KakaoShareProps
 * @param copyLink? CopyLinkProps
 */ var ShareSelectModal = function(param) {
    var isVisible = param.isVisible, onClose = param.onClose, type = param.type, pageName = param.pageName, kakaoShare = param.kakaoShare, copyLink = param.copyLink;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var ref = (0,react.useState)(false), _isVisible = ref[0], _setIsVisible = ref[1];
    var ref1 = (0,react.useState)(), shareItems = ref1[0], setShareItems = ref1[1];
    var eventNamePath = type.toLocaleLowerCase();
    // 공유하기 [카카오]
    var onShareKakao = (0,react.useCallback)(function() {
        if (!window.Kakao.isInitialized()) {
            window.Kakao.init("b921b0231b604bf1aea6460c3d26cb57");
        }
        if (kakaoShare) {
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_share_kakao_click"),
                    pageName: pageName,
                    payload: {
                        id: kakaoShare.id
                    }
                }
            });
            var Kakao = window.Kakao;
            if (type === KAKAO_SHARE_TYPE.QNA) {
                Kakao.Share.sendCustom({
                    templateId: 90853,
                    templateArgs: {
                        questionPid: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.MAGAZINE) {
                Kakao.Share.sendCustom({
                    templateId: 90880,
                    templateArgs: {
                        magazinePid: kakaoShare.id,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        titleImageUrl: kakaoShare.imageUrl
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.BOARD_POST) {
                Kakao.Share.sendCustom({
                    templateId: 94245,
                    templateArgs: {
                        id: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.NON_BENEFIT_MAP) {
                Kakao.Share.sendCustom({
                    templateId: 114723,
                    templateArgs: {
                        diagnosisTypeId: kakaoShare.id,
                        treatmentMedicineId: kakaoShare.subId,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        thumbnailUrl: kakaoShare.imageUrl
                    }
                });
            }
        }
        onClose();
    }, [
        type,
        kakaoShare,
        eventNamePath,
        pageName,
        onClose
    ]);
    // 공유하기 [링크복사]
    var onCopyLink = (0,react.useCallback)(function() {
        if (copyLink) {
            var ref;
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_copy_link_click"),
                    pageName: pageName,
                    payload: {
                        id: copyLink === null || copyLink === void 0 ? void 0 : copyLink.id
                    }
                }
            });
            (ref = document.getElementById(copyLink === null || copyLink === void 0 ? void 0 : copyLink.copyElementId)) === null || ref === void 0 ? void 0 : ref.click();
        }
        onClose();
    }, [
        copyLink,
        eventNamePath,
        pageName,
        onClose
    ]);
    var onCompleteCopy = function() {
        showToast({
            message: "클립보드로 복사되었습니다."
        });
    };
    var generateSelectList = (0,react.useCallback)(function() {
        var selectItems = [];
        if (copyLink) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            hasWrapper: true
                        });
                    },
                    text: "링크 복사",
                    onClick: onCopyLink
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        if (kakaoShare) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Kakao, {});
                    },
                    text: "카카오톡으로 공유",
                    onClick: onShareKakao
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        setShareItems(selectItems);
    }, [
        copyLink,
        onShareKakao,
        onCopyLink,
        kakaoShare,
        setShareItems
    ]);
    (0,react.useEffect)(function() {
        generateSelectList();
    }, [
        generateSelectList
    ]);
    (0,react.useEffect)(function() {
        _setIsVisible(isVisible);
    }, [
        isVisible
    ]);
    // https://sharer.kakao.com/picker/link?app_key=b921b0231b604bf1aea6460c3d26cb57&short_key=7007dc80-2f45-494f-a8fc-3ad2b18dd522
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    defer: true,
                    src: "https://developers.kakao.com/sdk/js/kakao.min.js"
                })
            }),
            _isVisible && !!shareItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectModal/* default */.Z, {
                modalTitle: "공유하기",
                selectList: shareItems,
                onClose: onClose
            }),
            !!copyLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: copyLink.copyLinkUrl,
                onCopy: onCompleteCopy,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    id: copyLink.copyElementId
                })
            })
        ]
    });
};
/* harmony default export */ var SelectModal_ShareSelectModal = (ShareSelectModal);


/***/ }),

/***/ 29305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var qrcode_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84059);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46870);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 20px 32px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  color: ",
        ";\n  padding: 0 4px;\n  white-space: pre-line;\n  margin-bottom: 20px;\n  word-break: keep-all;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  color: ",
        ";\n  margin-bottom: 24px;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 24px;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 141px;\n  object-fit: cover;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 56px;\n  border-radius: 12px;\n  margin-top: 40px;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var DiagnosisAppInstallBottomSheet = function(param) {
    var buttonId = param.buttonId, onClose = param.onClose, title = param.title, _treatmentMedicineId = param.treatmentMedicineId, treatmentMedicineId = _treatmentMedicineId === void 0 ? "0" : _treatmentMedicineId, description = param.description, qrCodeUrl = param.qrCodeUrl, onClickOpenAppInstallLink = param.onClickOpenAppInstallLink, client = param.client;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        isOpened: true,
        onClickOverlay: onClose,
        index: 500,
        children: client.isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReceiptImage, {
                        src: "/images/nonBenefit/image_mobile_seo.png",
                        alt: "계산서 이미지"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubmitButton, {
                    id: buttonId ? buttonId : "selected-medicine-".concat(treatmentMedicineId),
                    onClick: onClickOpenAppInstallLink,
                    children: "앱에서 최저가 확인하기"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QRCodeWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(qrcode_react__WEBPACK_IMPORTED_MODULE_2__/* .QRCodeCanvas */ .Qd, {
                        value: qrCodeUrl,
                        size: 120
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Description, {
                    children: description
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DiagnosisAppInstallBottomSheet);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-15deb100-0"
})(_templateObject());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-15deb100-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI22SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray900;
});
var Description = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-15deb100-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var QRCodeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-15deb100-3"
})(_templateObject3());
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-15deb100-4"
})(_templateObject4());
var ReceiptImage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-15deb100-5"
})(_templateObject5());
var SubmitButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-15deb100-6"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject6(), theme.typography.UI17SB, theme.color.white, theme.color.primary600);
});


/***/ }),

/***/ 97110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4415);


var useLoginViewModel = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var redirectUrl = router.query["redirect_url"] || "/";
    var isLoggedIn = !!(0,_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__/* .getAuthToken */ .bW)();
    var redirect = function() {
        router.push(redirectUrl);
    };
    return {
        isLoggedIn: isLoggedIn,
        redirect: redirect,
        redirectUrl: redirectUrl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useLoginViewModel);


/***/ }),

/***/ 96159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ useNonBenefitMedicinesForSeoQuery; },
/* harmony export */   "X9": function() { return /* binding */ useNonBenefitPriceTotalSummaryQuery; },
/* harmony export */   "Y1": function() { return /* binding */ useNonBenefitMapNearbyPharmacySearchTabsQuery; },
/* harmony export */   "Y6": function() { return /* binding */ useSearchNonF2fDoctorsForSeoByUserQuery; }
/* harmony export */ });
/* unused harmony exports NonBenefitMedicinesForSeoDocument, NonBenefitPriceTotalSummaryDocument, SearchNonF2fDoctorsForSeoByUserDocument, NonBenefitMapNearbyPharmacySearchTabsDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var NonBenefitMedicinesForSeoDocument = "\n    query NonBenefitMedicinesForSeo {\n  nonBenefitMedicinesForSeo {\n    id\n    medicineName\n    medicineDescription\n    units {\n      id\n      unit\n      unitType\n      unitTypeDisplayName\n    }\n    treatment {\n      id\n      categoryId\n      isBenefit\n      name\n    }\n  }\n}\n    ";
var useNonBenefitMedicinesForSeoQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "NonBenefitMedicinesForSeo"
    ] : [
        "NonBenefitMedicinesForSeo",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMedicinesForSeoDocument, "NonBenefitMedicinesForSeo", variables), options);
};
useNonBenefitMedicinesForSeoQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NonBenefitMedicinesForSeo"
    ] : [
        "NonBenefitMedicinesForSeo",
        variables
    ];
};
useNonBenefitMedicinesForSeoQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMedicinesForSeoDocument, "NonBenefitMedicinesForSeo", variables, options);
};
var NonBenefitPriceTotalSummaryDocument = "\n    query NonBenefitPriceTotalSummary($treatmentMedicineId: ID!, $regionCode: String!) {\n  nonBenefitPriceTotalSummary(\n    treatmentMedicineId: $treatmentMedicineId\n    regionCode: $regionCode\n  ) {\n    nationalSummaries {\n      averagePrice\n      minPrice\n      treatmentMedicineUnitId\n      unitDisplayName\n      unitTypeDisplayName\n    }\n    regionSummaries {\n      averagePrice\n      minPrice\n      treatmentMedicineUnitId\n      unitDisplayName\n      unitTypeDisplayName\n    }\n  }\n}\n    ";
var useNonBenefitPriceTotalSummaryQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "NonBenefitPriceTotalSummary",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitPriceTotalSummaryDocument, "NonBenefitPriceTotalSummary", variables), options);
};
useNonBenefitPriceTotalSummaryQuery.getKey = function(variables) {
    return [
        "NonBenefitPriceTotalSummary",
        variables
    ];
};
useNonBenefitPriceTotalSummaryQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitPriceTotalSummaryDocument, "NonBenefitPriceTotalSummary", variables, options);
};
var SearchNonF2fDoctorsForSeoByUserDocument = "\n    query SearchNonF2fDoctorsForSeoByUser($request: NonF2fDoctorSeoSearchRequestInput!, $contactType: DiagnosisContactType!) {\n  searchNonF2fDoctorsForSeoByUser(request: $request) {\n    doctorId\n    name\n    medicineType\n    readyForVideoCall\n    publicId\n    nonBenefitTreatmentsV2(contactType: $contactType) {\n      nonBenefitTreatmentUnitInfos {\n        originalPrice\n        unitDisplayName\n        treatmentMedicineUnitId\n      }\n    }\n    detail {\n      profileImageUrl\n    }\n    departments {\n      name\n      isProfessional\n    }\n    hospital {\n      hospitalName\n      hospitalAddress {\n        jibunAddress\n        roadAddress\n        regionByDepth {\n          siDoName\n          siGunGuName\n          legalEupMyeonDongName\n        }\n      }\n    }\n  }\n}\n    ";
var useSearchNonF2fDoctorsForSeoByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchNonF2fDoctorsForSeoByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchNonF2fDoctorsForSeoByUserDocument, "SearchNonF2fDoctorsForSeoByUser", variables), options);
};
useSearchNonF2fDoctorsForSeoByUserQuery.getKey = function(variables) {
    return [
        "SearchNonF2fDoctorsForSeoByUser",
        variables
    ];
};
useSearchNonF2fDoctorsForSeoByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchNonF2fDoctorsForSeoByUserDocument, "SearchNonF2fDoctorsForSeoByUser", variables, options);
};
var NonBenefitMapNearbyPharmacySearchTabsDocument = "\n    query NonBenefitMapNearbyPharmacySearchTabs {\n  nonBenefitMapNearbyPharmacySearchTabs {\n    id\n    name\n    diagnosisType\n    diagnosisTypeId\n    sortTypes {\n      type\n      title\n    }\n    filters {\n      type\n      title\n      description\n      mode\n      activeIconUrl\n      inactiveIconUrl\n      subFilters {\n        type\n        title\n        description\n        mode\n        inactiveIconUrl\n        activeIconUrl\n      }\n    }\n  }\n}\n    ";
var useNonBenefitMapNearbyPharmacySearchTabsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables), options);
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ];
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables, options);
};


/***/ }),

/***/ 79832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSearchCriteria */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98240);
/* harmony import */ var _parsers_f2f_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89325);
/* harmony import */ var _parsers_pharmacy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57690);
/* harmony import */ var _services_pharmacy_PharmacyPickupService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39826);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72271);
/* harmony import */ var _pharmacy_gql_impl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39466);







var getSearchCriteria = function(diagnosisType, diagnosisTypeId, treatmentMedicineId, dispensationUnit) {
    if (!diagnosisType) {
        return {};
    }
    if (!diagnosisTypeId) {
        return {};
    }
    if (diagnosisType === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisType.Treatment */ .LE.Treatment) {
        return {
            medicineSearchCriteria: {
                treatmentId: diagnosisTypeId,
                treatmentMedicineId: treatmentMedicineId,
                dispensationUnit: dispensationUnit
            }
        };
    }
    if (diagnosisType === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisType.Department */ .LE.Department) {
        return {
            departmentSearchCriteria: {
                departmentId: diagnosisTypeId
            }
        };
    }
    return {};
};
var useFindGeneralListOfNearbyPharmacyV3ByUser = function(queryRequest) {
    var latitude = queryRequest.latitude, longitude = queryRequest.longitude, diagnosisType = queryRequest.diagnosisType, diagnosisTypeId = queryRequest.diagnosisTypeId, treatmentMedicineId = queryRequest.treatmentMedicineId, dispensationUnit = queryRequest.dispensationUnit, shouldIncludeDiagnosisPrice = queryRequest.shouldIncludeDiagnosisPrice, restQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(queryRequest, [
        "latitude",
        "longitude",
        "diagnosisType",
        "diagnosisTypeId",
        "treatmentMedicineId",
        "dispensationUnit",
        "shouldIncludeDiagnosisPrice"
    ]);
    var isEnabled = function() {
        if (shouldIncludeDiagnosisPrice && !treatmentMedicineId && !dispensationUnit) {
            return false;
        }
        return !!restQuery.northEastLatitude && !!restQuery.northEastLongitude && !!restQuery.southWestLatitude && !!restQuery.southWestLongitude;
    };
    var mapCoordinate = _services_pharmacy_PharmacyPickupService__WEBPACK_IMPORTED_MODULE_2__/* .PharmacyPickupService.getMapCoordinate */ .B.getMapCoordinate(restQuery);
    var userCoordinate = (0,_parsers_f2f_common__WEBPACK_IMPORTED_MODULE_0__/* .getCoordinate */ .FY)(latitude, longitude);
    var ref = (0,_pharmacy_gql_impl__WEBPACK_IMPORTED_MODULE_4__/* .useFindGeneralListOfNearbyPharmacyV3ByUserQuery */ .xT)({
        request: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, {
            userLocation: {
                latitude: userCoordinate.latitude,
                longitude: userCoordinate.longitude
            },
            geoBound: {
                northEastLatitude: mapCoordinate.northEastLatitude,
                northEastLongitude: mapCoordinate.northEastLongitude,
                southWestLatitude: mapCoordinate.southWestLatitude,
                southWestLongitude: mapCoordinate.southWestLongitude
            },
            page: 1
        }, getSearchCriteria(diagnosisType, diagnosisTypeId, treatmentMedicineId, dispensationUnit)),
        treatmentId: diagnosisTypeId,
        treatmentMedicineId: treatmentMedicineId,
        dispensationUnit: dispensationUnit,
        shouldIncludeCheapestMedicine: !!treatmentMedicineId && !!dispensationUnit,
        shouldIncludeDiagnosisPrice: shouldIncludeDiagnosisPrice
    }, {
        select: _parsers_pharmacy__WEBPACK_IMPORTED_MODULE_1__/* .parseGeneralListOfNearbyPharmacy */ .af,
        enabled: isEnabled()
    }), data = ref.data, isFetching = ref.isFetching, isLoading = ref.isLoading;
    return {
        isLoading: isFetching || isLoading,
        data: data !== null && data !== void 0 ? data : []
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFindGeneralListOfNearbyPharmacyV3ByUser);


/***/ }),

/***/ 38139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ non_benefit_map; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-nonbenefit/ui/NonBenefitPharmacyHeader.tsx



var NonBenefitPharmacyHeader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: "flex items-center justify-between px-6 pb-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "typography-ui-22sb",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: props.handleOpenShareModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                        name: "share",
                        color: theme/* default.color.gray600 */.Z.color.gray600,
                        size: 24
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: "flex h-12 items-center justify-between px-5 py-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "typography-ui-22sb",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: props.handleOpenShareModal,
                    className: "flex flex h-12 items-center items-center gap-2 rounded-lg border border-solid border-gray-100 px-5 typography-ui-16sb",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "share",
                            color: theme/* default.color.gray600 */.Z.color.gray600,
                            size: 20
                        }),
                        "공유하기"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ui_NonBenefitPharmacyHeader = (NonBenefitPharmacyHeader);

// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/Filter/Filter.tsx
var Filter = __webpack_require__(57266);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyScrollFilters/PharmacyScrollFilters.tsx
var PharmacyScrollFilters = __webpack_require__(98264);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/components/molecules/BottomActionSheet/index.tsx
var BottomActionSheet = __webpack_require__(72673);
// EXTERNAL MODULE: ./src/constants/ddActions/pharmacy/index.ts
var pharmacy = __webpack_require__(77292);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/Modals/AddressesModal.tsx
var AddressesModal = __webpack_require__(15517);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ./src/features/pharmacies/pharmacies-find/ui/MedicineInfoBottomSheet.tsx + 1 modules
var MedicineInfoBottomSheet = __webpack_require__(53199);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/hooks/usePharmacyFilterViewModel.ts
var usePharmacyFilterViewModel = __webpack_require__(65669);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useGetNearbyPharmacySortsAndFiltersWithSubFilters.ts
var useGetNearbyPharmacySortsAndFiltersWithSubFilters = __webpack_require__(51689);
// EXTERNAL MODULE: ./src/hooks/pharmacy/usePharmacyLocation.ts
var usePharmacyLocation = __webpack_require__(46088);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useTreatmentMedicinesByTreatmentId.ts
var useTreatmentMedicinesByTreatmentId = __webpack_require__(71486);
// EXTERNAL MODULE: ./src/models/pharmacy/index.ts
var models_pharmacy = __webpack_require__(75203);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-nonbenefit/viewModels/useNonBenefitPharmacyFilterViewModel.ts








function useNonBenefitPharmacyFilterViewModel(param) {
    var selectedTab = param.selectedTab, defaultSort = param.defaultSort, onApplyFilter = param.onApplyFilter, onClickCurrentLocation = param.onClickCurrentLocation;
    // 정렬 및 필터 옵션 가져오기
    var nearbyPharmacySortsAndFilters = (0,useGetNearbyPharmacySortsAndFiltersWithSubFilters/* default */.Z)({
        diagnosisId: (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id) || "",
        enabled: !!(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id)
    }).nearbyPharmacySortsAndFilters;
    // 처방약 목록 가져오기
    var ref = (0,useTreatmentMedicinesByTreatmentId/* default */.Z)((selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.diagnosisTypeId) || ""), treatmentMedicinesData = ref.data;
    // 공통 필터 뷰모델 초기화
    var commonFilterViewModel = (0,usePharmacyFilterViewModel/* default */.Z)({
        selectedTab: selectedTab,
        defaultSort: defaultSort,
        nearbyPharmacySortsAndFilters: nearbyPharmacySortsAndFilters,
        onApplyFilter: onApplyFilter
    });
    // 약국 위치 관련 훅 초기화
    var locationHook = (0,usePharmacyLocation/* default */.Z)();
    // 약 정보 관련 상태
    var ref1 = (0,react.useState)(false), isMedicineInfoOpen = ref1[0], setIsMedicineInfoOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isSortBottomSheetOpen = ref2[0], setIsSortBottomSheetOpen = ref2[1];
    // 주소 관련 액션
    var addressActions = {
        openAddressSelectModal: function() {
            return {
                addresses: locationHook.addresses,
                onOpenAddressListScreen: locationHook.goToAppMyPageAddressScreen,
                onRequestCurrentPosition: onClickCurrentLocation
            };
        }
    };
    // 바텀시트 핸들러
    var openSortBottomSheet = function() {
        return setIsSortBottomSheetOpen(true);
    };
    var closeSortBottomSheet = function() {
        return setIsSortBottomSheetOpen(false);
    };
    var handleMedicineInfoClick = function() {
        return setIsMedicineInfoOpen(true);
    };
    var handleCloseMedicineInfo = function() {
        return setIsMedicineInfoOpen(false);
    };
    // 필터 선택 핸들러
    var handleFilterClick = function(filter) {
        commonFilterViewModel.toggleFilter(filter);
    };
    // 정렬 선택 핸들러
    var handleSortSelected = (0,react.useCallback)(function(sort) {
        var newCriteria = {
            selectedMedicine: commonFilterViewModel.localFilterCriteria.selectedMedicine,
            selectedCommonFilters: commonFilterViewModel.localFilterCriteria.selectedCommonFilters,
            includeDiagnosisPriceFilter: commonFilterViewModel.localFilterCriteria.includeDiagnosisPriceFilter,
            selectedSortMethod: sort
        };
        onApplyFilter(newCriteria);
        closeSortBottomSheet();
    }, [
        commonFilterViewModel.localFilterCriteria,
        onApplyFilter
    ]);
    // 약 관련 핸들러
    var handleMedicineClick = (0,react.useCallback)(function(medicine) {
        if (!medicine.dispensationUnits.length) {
            return;
        }
        // 기본 단위 찾기 (isDefault가 true인 단위 또는 첫 번째 단위)
        var defaultUnit = medicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || medicine.dispensationUnits[0];
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(medicine, defaultUnit, medicine.treatmentMedicineId);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        commonFilterViewModel,
        onApplyFilter
    ]);
    var handleDispensationUnitClick = (0,react.useCallback)(function(unit) {
        var ref;
        if (!((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine)) {
            return;
        }
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine, unit, commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicineId);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter,
            includeDiagnosisPriceFilter: commonFilterViewModel.localFilterCriteria.includeDiagnosisPriceFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        commonFilterViewModel,
        onApplyFilter
    ]);
    // 조건부 UI 표시 관련 함수
    var shouldShowTreatmentMedicineFilter = (0,react.useCallback)(function() {
        return !!(treatmentMedicinesData === null || treatmentMedicinesData === void 0 ? void 0 : treatmentMedicinesData.length);
    }, [
        treatmentMedicinesData
    ]);
    var shouldShowDiagnosisPriceFilter = (0,react.useCallback)(function() {
        return !!commonFilterViewModel.localFilterCriteria.selectedMedicine;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    // 약/단위 선택 관련 헬퍼 함수
    var isMedicineSelected = (0,react.useCallback)(function(medicine) {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.treatmentMedicineId) === medicine.treatmentMedicineId;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var getSelectedMedicineUnits = (0,react.useCallback)(function() {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.dispensationUnits) || [];
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var isDispensationUnitSelected = (0,react.useCallback)(function(unit) {
        var ref, ref1;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : (ref1 = ref.dispensationUnit) === null || ref1 === void 0 ? void 0 : ref1.dispensationUnit) === unit.dispensationUnit;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    // 초기 약 선택 설정
    (0,react.useEffect)(function() {
        // 약이 있고 아직 선택되지 않았을 때만 처리
        if (!(treatmentMedicinesData === null || treatmentMedicinesData === void 0 ? void 0 : treatmentMedicinesData.length) || commonFilterViewModel.localFilterCriteria.selectedMedicine) {
            return;
        }
        var firstMedicine = treatmentMedicinesData[0];
        var defaultUnit = firstMedicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || firstMedicine.dispensationUnits[0];
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(firstMedicine, defaultUnit, firstMedicine.treatmentMedicineId);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        treatmentMedicinesData,
        commonFilterViewModel,
        onApplyFilter
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel), {
        locationHook: locationHook,
        addressActions: addressActions,
        // 정렬 관련 상태 및 메서드
        isSortBottomSheetOpen: isSortBottomSheetOpen,
        openSortBottomSheet: openSortBottomSheet,
        closeSortBottomSheet: closeSortBottomSheet,
        // 필터 및 정렬 핸들러
        handleFilterClick: handleFilterClick,
        handleSortSelected: handleSortSelected,
        // 약 관련 상태 및 메서드
        isMedicineInfoOpen: isMedicineInfoOpen,
        handleMedicineInfoClick: handleMedicineInfoClick,
        handleCloseMedicineInfo: handleCloseMedicineInfo,
        treatmentMedicines: treatmentMedicinesData || [],
        handleMedicineClick: handleMedicineClick,
        handleDispensationUnitClick: handleDispensationUnitClick,
        shouldShowTreatmentMedicineFilter: shouldShowTreatmentMedicineFilter,
        isMedicineSelected: isMedicineSelected,
        getSelectedMedicineUnits: getSelectedMedicineUnits,
        isDispensationUnitSelected: isDispensationUnitSelected,
        shouldShowDiagnosisPriceFilter: shouldShowDiagnosisPriceFilter
    });
}

;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-nonbenefit/ui/NonBenefitPharmacyHeaderFilter.tsx














var NonBenefitPharmacyHeaderFilter = function(props) {
    var ref, ref1;
    var ref2 = (0,useModal/* default */.Z)(), showModal = ref2.showModal, closeModal = ref2.closeModal;
    var viewModel = useNonBenefitPharmacyFilterViewModel({
        client: props.client,
        selectedTab: props.selectedTab,
        defaultSort: props.defaultSort,
        onApplyFilter: props.onApplyFilter,
        onClickCurrentLocation: props.onClickCurrentLocation
    });
    var openAddressSelectModal = function() {
        var addressOptions = viewModel.addressActions.openAddressSelectModal();
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressesModal/* default */.Z, {
                    client: props.client,
                    addresses: addressOptions.addresses,
                    onOpenAddressListScreen: addressOptions.onOpenAddressListScreen,
                    onRequestCurrentPosition: function() {
                        var ref;
                        (ref = addressOptions.onRequestCurrentPosition) === null || ref === void 0 ? void 0 : ref.call(addressOptions);
                        closeModal();
                    }
                }),
                onClickOverlay: closeModal
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PharmacyScrollFilters/* default */.Z, {
                    pharmacyFilters: viewModel.searchFiltersHook.pharmacyFilterListWithoutIncludeDiagnosisPriceFilter,
                    onClickSearchCommonFilter: viewModel.handleFilterClick,
                    onClickListFilter: viewModel.handleFilterClick,
                    selectedFilters: viewModel.localFilterCriteria.selectedCommonFilters,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            params: {
                                eventName: pharmacy/* PharmacyDdAction.ClickLocation */.Fe.ClickLocation,
                                payload: {
                                    location: props.currentDongLi
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter/* default.LargeFilter */.Z.LargeFilter, {
                                onClick: openAddressSelectModal,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                        name: "my_location",
                                        size: 16,
                                        color: theme/* default.color.gray700 */.Z.color.gray700,
                                        filled: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.currentDongLi
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-[4px] h-full min-w-[1px] bg-gray-30"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            params: {
                                eventName: pharmacy/* PharmacyDdAction.ClickSort */.Fe.ClickSort
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter/* default.LargeFilter */.Z.LargeFilter, {
                                onClick: viewModel.openSortBottomSheet,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                        name: "swap_vert",
                                        size: 16,
                                        color: theme/* default.color.gray700 */.Z.color.gray700,
                                        filled: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: viewModel.localFilterCriteria.selectedSortMethod.title
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            viewModel.shouldShowTreatmentMedicineFilter() && viewModel.localFilterCriteria.selectedMedicine && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col divide-y divide-solid divide-gray-30 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-10 w-full flex-row items-center gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-20 items-center gap-[2px] pl-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "typography-ui-13sb text-gray-800",
                                        children: "처방약"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "flex cursor-pointer items-center justify-center border-0 bg-none",
                                        onClick: viewModel.handleMedicineInfoClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/pharmacy/info_gray.svg",
                                            alt: "정보",
                                            width: "14",
                                            height: "14"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scrollbar-hide flex flex-1 items-center gap-2 overflow-x-auto whitespace-nowrap pr-12",
                                children: (ref = viewModel.treatmentMedicines) === null || ref === void 0 ? void 0 : ref.map(function(medicine) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,style.cn)("typography-ui-13sb flex h-10 items-center px-1", viewModel.isMedicineSelected(medicine) ? "text-primary-700" : "typography-ui-13m text-gray-600"),
                                        onClick: function() {
                                            return viewModel.handleMedicineClick(medicine);
                                        },
                                        children: medicine.name
                                    }, medicine.treatmentMedicineId);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-10 w-full flex-row items-center gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-20 items-center pl-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "typography-ui-13sb text-gray-800",
                                    children: "처방단위"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scrollbar-hide flex flex-1 items-center gap-2 overflow-x-auto whitespace-nowrap pr-12",
                                children: viewModel.getSelectedMedicineUnits().map(function(unit) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,style.cn)("typography-ui-13sb flex h-10 items-center px-1", viewModel.isDispensationUnitSelected(unit) ? "text-primary-700" : "typography-ui-13m text-gray-600"),
                                        onClick: function() {
                                            return viewModel.handleDispensationUnitClick(unit);
                                        },
                                        children: unit.dispensationUnitDisplayName
                                    }, unit.dispensationUnit);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomActionSheet/* default */.ZP, {
                isOpened: viewModel.isSortBottomSheetOpen,
                onClickOverlay: viewModel.closeSortBottomSheet,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "typography-ui-20sb px-[12px] pb-4 text-left text-gray-900",
                            children: "어떤 순서로 정렬할까요?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col",
                            children: viewModel.searchFiltersHook.pharmacySorts.map(function(sort, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex cursor-pointer items-center justify-between rounded-lg px-3 py-4",
                                    onClick: function() {
                                        return viewModel.handleSortSelected(sort);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "typography-ui-17m text-gray-900",
                                            children: sort.title
                                        }),
                                        sort.type === viewModel.localFilterCriteria.selectedSortMethod.type && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "check",
                                                color: theme/* default.color.primary600 */.Z.color.primary600,
                                                size: 24
                                            })
                                        })
                                    ]
                                }, "sort-".concat(index));
                            })
                        })
                    ]
                })
            }),
            viewModel.isMedicineInfoOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineInfoBottomSheet/* default */.Z, {
                diagnosisTypeId: ((ref1 = props.selectedTab) === null || ref1 === void 0 ? void 0 : ref1.diagnosisTypeId) || null,
                onClickClose: viewModel.handleCloseMedicineInfo
            })
        ]
    });
};
/* harmony default export */ var ui_NonBenefitPharmacyHeaderFilter = (NonBenefitPharmacyHeaderFilter);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/LoginModal/index.tsx + 5 modules
var LoginModal = __webpack_require__(4329);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/ShareSelectModal/index.tsx + 1 modules
var ShareSelectModal = __webpack_require__(22701);
// EXTERNAL MODULE: ./src/components/molecules/Overlay/index.tsx + 1 modules
var Overlay = __webpack_require__(78952);
// EXTERNAL MODULE: ./src/components/templates/communication/Faq/FaqTagListTemplate/index.tsx + 2 modules
var FaqTagListTemplate = __webpack_require__(9107);
// EXTERNAL MODULE: ./src/constants/logs/pharmacy/index.tsx
var logs_pharmacy = __webpack_require__(15255);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/EmptyPharmacyToast/EmptyPharmacyToast.tsx
var EmptyPharmacyToast = __webpack_require__(48929);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyCardBottomSheet/PharmacyCardBottomSheet.tsx + 3 modules
var PharmacyCardBottomSheet = __webpack_require__(74541);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyListBottomSheet/PharmacyListBottomSheet.tsx + 8 modules
var PharmacyListBottomSheet = __webpack_require__(20431);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyMapContainer/PharmacyMapContainer.tsx + 13 modules
var PharmacyMapContainer = __webpack_require__(87487);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyMapHeaderTabs/PharmacyMapHeaderTabs.tsx + 1 modules
var PharmacyMapHeaderTabs = __webpack_require__(23490);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/pharmacy.ts
var types_pharmacy = __webpack_require__(6271);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/components/templates/pharmacy/detail/components/PharmacyInfoHeader/index.tsx
var PharmacyInfoHeader = __webpack_require__(89584);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/map/NonBenefitMapTemplate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  height: 48px;\n  padding: 0 20px;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 8px;\n  color: white;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


























var NonBenefitMapTemplate = function(param) {
    var viewModel = param.viewModel, client = param.client, title = param.title;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var router = (0,next_router.useRouter)();
    var ref9 = (0,react.useState)(false), isShowShareModal = ref9[0], setShowShareModal = ref9[1];
    var diagnosisTypeId = (ref = viewModel.selectedTab) === null || ref === void 0 ? void 0 : ref.diagnosisTypeId;
    var treatmentProductMedicineName = (ref1 = viewModel.selectedMedicine) === null || ref1 === void 0 ? void 0 : ref1.treatmentProductMedicineName;
    var treatmentProductShareImageUrl = (ref2 = viewModel.selectedMedicine) === null || ref2 === void 0 ? void 0 : ref2.treatmentProductShareImageUrl;
    var treatmentMedicineId = (ref3 = viewModel.selectedTreatmentMedicine) === null || ref3 === void 0 ? void 0 : ref3.treatmentMedicine.treatmentMedicineId;
    var handleOpenShareModal = function() {
        setShowShareModal(true);
    };
    var handleCloseShareModal = function() {
        setShowShareModal(false);
    };
    var _selectedPharmacy, ref10, ref11, ref12, _isIncludeDiagnosisPriceFilterSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqTagListTemplate/* BreadCrumbsWrapper */.X, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                    visible: true,
                    breadCrumbs: viewModel.breadCrumbs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_NonBenefitPharmacyHeader, {
                                isMobile: client.isMobile,
                                title: title,
                                handleOpenShareModal: handleOpenShareModal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyMapHeaderTabs/* default */.Z, {
                                tabs: viewModel.tabs,
                                selectedTab: viewModel.selectedTab,
                                onClickTab: viewModel.onClickTab
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyMapContainer/* default */.Z, {
                                selectedPharmacy: viewModel.selectedPharmacy,
                                updatePharmacyMapInitiateError: viewModel.updatePharmacyMapInitiateError,
                                level: 9,
                                isPharmaciesLoading: viewModel.isNearbyPharmaciesLoading,
                                centerCoordinate: viewModel.currentLocation,
                                pharmacies: viewModel.pharmacies,
                                updateDongLiName: viewModel.updateDongLiName,
                                updateMapCoordinate: viewModel.updateCurrentMapCoordinate,
                                isVisibleMedicinePrice: viewModel.isSelectedLowPrice,
                                shouldShowDiagnosisPrice: viewModel.isIncludeDiagnosisPriceFilterSelected,
                                resetSelectedPharmacy: viewModel.resetSelectedPharmacy,
                                updateSelectedPharmacy: viewModel.updateSelectedPharmacy,
                                mapRef: viewModel.mapRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyListBottomSheet/* default */.Z, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_NonBenefitPharmacyHeaderFilter, {
                            client: client,
                            selectedTab: viewModel.selectedTab,
                            defaultSort: types_pharmacy/* ENearbyPharmacySearchSortType.LowPrice */.sZ.LowPrice,
                            currentDongLi: viewModel.dongLiName,
                            onApplyFilter: function(filterCriteria) {
                                return viewModel.applyFilter(filterCriteria);
                            },
                            onClickCurrentLocation: viewModel.onClickCurrentLocation
                        }),
                        client: client,
                        ref: viewModel.pharmacyListBottomSheetRef,
                        scrollListRef: viewModel.scrollListRef,
                        isNearbyPharmaciesLoading: viewModel.isNearbyPharmaciesLoading,
                        pharmacies: viewModel.pharmacies,
                        onClickPharmacyItem: viewModel.onClickPharmacyItem,
                        isIncludeDiagnosisPriceFilterSelected: viewModel.isIncludeDiagnosisPriceFilterSelected,
                        isSelectedLowPrice: viewModel.isSelectedLowPrice,
                        onClickCurrentLocation: viewModel.requestGeolocationPermissionInWeb,
                        headerHeight: client.isMobile ? 150 : 146,
                        shouldTransparent: viewModel.shouldShowPharmacyCard
                    }),
                    viewModel.shouldShowPharmacyCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyCardBottomSheet/* default */.Z, {
                        pharmacy: viewModel.selectedPharmacy,
                        isVisibleMedicinePrice: viewModel.isSelectedLowPrice,
                        shouldShowDiagnosisPrice: viewModel.isIncludeDiagnosisPriceFilterSelected,
                        clickViewListModeButton: viewModel.onClickViewListModeButtonWithResetSelectedPharmacy,
                        shouldShowPharmacyDetail: true,
                        onClickCurrentLocation: viewModel.requestGeolocationPermissionInWeb,
                        pharmacyMainInfoComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyInfoHeader/* default */.Z, {
                            pharmacy: (_selectedPharmacy = viewModel.selectedPharmacy) !== null && _selectedPharmacy !== void 0 ? _selectedPharmacy : viewModel.pharmacies[0],
                            openNowPharmacyInfo: viewModel.openNowPharmacyInfo,
                            onClickFavoritePharmacy: function(e) {
                                var _selectedPharmacy;
                                viewModel.onClickFavoritePharmacy(e, (_selectedPharmacy = viewModel.selectedPharmacy) !== null && _selectedPharmacy !== void 0 ? _selectedPharmacy : viewModel.pharmacies[0]);
                            }
                        }),
                        client: client,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyCardBottomSheet/* default.ButtonArea */.Z.ButtonArea, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                    params: {
                                        eventName: logs_pharmacy/* FindPharmacyLog.click_pharmacy_diagnosis_button */.Vq.click_pharmacy_diagnosis_button,
                                        payload: {
                                            pharmacyId: (ref10 = (ref4 = viewModel.selectedPharmacy) === null || ref4 === void 0 ? void 0 : ref4.pharmacyId) !== null && ref10 !== void 0 ? ref10 : 0,
                                            price: ((ref11 = (ref5 = viewModel.selectedPharmacy) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.pharmacyCheapestPriceMedicines) === null || ref6 === void 0 ? void 0 : ref6.totalAmount) !== null && ref11 !== void 0 ? ref11 : 0) + ((ref12 = (ref7 = viewModel.selectedPharmacy) === null || ref7 === void 0 ? void 0 : ref7.diagnosisPrice) !== null && ref12 !== void 0 ? ref12 : 0)
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyDiagnosisActionButton, {
                                        type: "button",
                                        onClick: viewModel.onOpenAppInstallBottomSheet,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyDiagnosisActionButtonText, {
                                            children: (ref8 = viewModel.selectedPharmacy) === null || ref8 === void 0 ? void 0 : ref8.getFindPharmacyDiagnosisActionButtonText((_isIncludeDiagnosisPriceFilterSelected = viewModel.isIncludeDiagnosisPriceFilterSelected) !== null && _isIncludeDiagnosisPriceFilterSelected !== void 0 ? _isIncludeDiagnosisPriceFilterSelected : false, viewModel.selectedTabName, viewModel.isSelectedAllTab())
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSelectModal/* default */.C, {
                isVisible: isShowShareModal,
                onClose: handleCloseShareModal,
                type: ShareSelectModal/* KAKAO_SHARE_TYPE.NON_BENEFIT_MAP */.Z.NON_BENEFIT_MAP,
                pageName: (0,logger/* getPageName */.j0)(router),
                kakaoShare: {
                    id: diagnosisTypeId !== null && diagnosisTypeId !== void 0 ? diagnosisTypeId : "",
                    subId: treatmentMedicineId !== null && treatmentMedicineId !== void 0 ? treatmentMedicineId : "",
                    title: "".concat(treatmentProductMedicineName, " 최저가 약국 찾기"),
                    content: "내 근처에서 가장 저렴한 ".concat(treatmentProductMedicineName, " 가격을 확인하고 비교할 수 있어요."),
                    imageUrl: treatmentProductShareImageUrl
                },
                copyLink: {
                    id: diagnosisTypeId !== null && diagnosisTypeId !== void 0 ? diagnosisTypeId : "",
                    copyElementId: "copyNonBenefitMap",
                    copyLinkUrl: "".concat((0,format/* formatShareUrl */.zm)(common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path), "?diagnosisTypeId=").concat(diagnosisTypeId, "&treatmentMedicineId=").concat(treatmentMedicineId, "&latitude=").concat(viewModel.currentMapLocation.latitude, "&longitude=").concat(viewModel.currentMapLocation.longitude)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyPharmacyToast/* default */.Z, {
                shouldShowToast: viewModel.shouldShowEmptyPharmacyMessage()
            }),
            viewModel.showLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
                onClickOverlay: viewModel.closeLoginModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal/* default */.Z, {
                    isWritePage: false,
                    onClick: viewModel.closeLoginModal,
                    redirectUrl: "",
                    trackInfo: {
                        campaign: "doctor_detail",
                        content: "doctor_detail_family_doctor_add_remove",
                        buttonText: "단골 의사 추가/삭제"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var map_NonBenefitMapTemplate = (NonBenefitMapTemplate);
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ea193b-0"
})(_templateObject(), function(param) {
    var _$theme = param.theme;
    if (_$theme.client.isMobile) {
        return "calc(100dvh - 110px)";
    }
    return "calc(100dvh - 106px)";
});
var PharmacyDiagnosisActionButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c4ea193b-1"
})(_templateObject1(), theme/* default.color.primary600 */.Z.color.primary600);
var PharmacyDiagnosisActionButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c4ea193b-2"
})(_templateObject2(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI16SB, "\n  ");
});
var BottomWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ea193b-3"
})(_templateObject3());

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/components/templates/nonBenefit/home/components/DiagnosisAppInstallBottomSheet.tsx
var DiagnosisAppInstallBottomSheet = __webpack_require__(29305);
// EXTERNAL MODULE: ./src/constants/url.ts
var url = __webpack_require__(26093);
// EXTERNAL MODULE: ./src/services/pharmacy/PharmacyPickupService.ts
var PharmacyPickupService = __webpack_require__(39826);
// EXTERNAL MODULE: ./src/utils/url.ts
var utils_url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/features/pharmacies/shared/hooks/usePharmacyViewType.ts




var usePharmacyViewType = function() {
    var router = (0,next_router.useRouter)();
    var viewType = router.query.viewType;
    var pharmacyViewType = PharmacyPickupService/* PharmacyPickupService.getPharmacyViewType */.B.getPharmacyViewType(viewType);
    var shouldShowListView = pharmacyViewType === types_pharmacy/* EPharmacyViewType.List */.DO.List;
    var toggleViewMode = function() {
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: types_pharmacy/* PharmacySearchParamsQueries.ViewType */.Vc.ViewType,
                value: pharmacyViewType === types_pharmacy/* EPharmacyViewType.Map */.DO.Map ? types_pharmacy/* EPharmacyViewType.List */.DO.List : types_pharmacy/* EPharmacyViewType.Map */.DO.Map
            }, 
        ]);
    };
    return {
        pharmacyViewType: pharmacyViewType,
        shouldShowListView: shouldShowListView,
        toggleViewMode: toggleViewMode
    };
};
/* harmony default export */ var hooks_usePharmacyViewType = (usePharmacyViewType);

// EXTERNAL MODULE: ./src/parsers/f2f/common/index.ts
var f2f_common = __webpack_require__(89325);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
;// CONCATENATED MODULE: ./src/hooks/common/useWebLocation.ts








var useWebLocation = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), dongLiName = ref[0], setDongLiName = ref[1];
    var showToast = (0,useToast/* default */.Z)().showToast;
    var _query = router.query, latitude = _query.latitude, longitude = _query.longitude;
    var currentLocation = (0,f2f_common/* getCoordinate */.FY)(latitude, longitude);
    var updateSearchParamsLocation = function(param) {
        var latitude = param.latitude, longitude = param.longitude;
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: types_pharmacy/* PharmacySearchParamsQueries.Latitude */.Vc.Latitude,
                value: latitude
            },
            {
                key: types_pharmacy/* PharmacySearchParamsQueries.Longitude */.Vc.Longitude,
                value: longitude
            }, 
        ]);
    };
    var requestGeolocationPermissionInWeb = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(callback) {
            var isToast;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                isToast = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                if (!navigator.geolocation) {
                    return [
                        2
                    ];
                }
                navigator.geolocation.getCurrentPosition(function(param) {
                    var coords = param.coords;
                    updateSearchParamsLocation({
                        latitude: coords.latitude,
                        longitude: coords.longitude
                    });
                    callback && callback({
                        latitude: coords.latitude,
                        longitude: coords.longitude
                    });
                }, function() {
                    if (!isToast) return;
                    showToast({
                        message: "위치 권한 허용 후 다시 시도해주세요"
                    });
                }, {
                    enableHighAccuracy: false,
                    timeout: 7000
                });
                return [
                    2
                ];
            });
        });
        return function requestGeolocationPermissionInWeb(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateDongLiName = function(currentDongLiName) {
        setDongLiName(currentDongLiName);
    };
    return {
        dongLiName: dongLiName,
        currentLocation: currentLocation,
        updateDongLiName: updateDongLiName,
        requestGeolocationPermissionInWeb: requestGeolocationPermissionInWeb
    };
};
/* harmony default export */ var common_useWebLocation = (useWebLocation);

// EXTERNAL MODULE: ./src/hooks/pharmacy/useFilteredAndSortedPharmacy.ts
var useFilteredAndSortedPharmacy = __webpack_require__(95782);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useFindGeneralListOfNearbyPharmacyV3ByUser.ts
var useFindGeneralListOfNearbyPharmacyV3ByUser = __webpack_require__(79832);
// EXTERNAL MODULE: ./src/hooks/pharmacy/usePharmacySearchFilters.ts
var usePharmacySearchFilters = __webpack_require__(41841);
// EXTERNAL MODULE: ./src/models/nonBenefit/index.ts
var nonBenefit = __webpack_require__(83018);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/constants/map/index.ts
var map = __webpack_require__(13805);
// EXTERNAL MODULE: ./src/hooks/login/useLoginViewModel.ts
var useLoginViewModel = __webpack_require__(97110);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useAddFavoritePharmacy.ts
var useAddFavoritePharmacy = __webpack_require__(47272);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useFavoritePharmacies.ts
var useFavoritePharmacies = __webpack_require__(8201);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useRemoveFavoritePharmacy.ts
var useRemoveFavoritePharmacy = __webpack_require__(43928);
// EXTERNAL MODULE: ./src/hooks/useLogger.ts
var useLogger = __webpack_require__(8202);
// EXTERNAL MODULE: ./src/hooks/useToaster.tsx
var useToaster = __webpack_require__(37643);
// EXTERNAL MODULE: ./src/hooks/nonBenefit/nonBenefit.gql.impl.tsx
var nonBenefit_gql_impl = __webpack_require__(96159);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitMapNearbyPharmacySearchTabs.ts






// 타입 변환 매퍼 함수
var mapToPharmacyFilterMode = function(mode) {
    // PharmacyFilterMode와 EPharmacyFilterMode는 동일한 값을 가지므로 직접 매핑 가능
    switch(mode){
        case gql_schema/* PharmacyFilterMode.List */.T4.List:
            return types_pharmacy/* EPharmacyFilterMode.List */.LR.List;
        case gql_schema/* PharmacyFilterMode.Toggle */.T4.Toggle:
            return types_pharmacy/* EPharmacyFilterMode.Toggle */.LR.Toggle;
        case gql_schema/* PharmacyFilterMode.Range */.T4.Range:
            return types_pharmacy/* EPharmacyFilterMode.Range */.LR.Range;
        default:
            return types_pharmacy/* EPharmacyFilterMode.Toggle */.LR.Toggle;
    }
};
var mapToPharmacySearchFilterType = function(type) {
    // PharmacyFilterType을 ENearbyPharmacySearchFilterType으로 매핑
    switch(type){
        case gql_schema/* PharmacyFilterType.ConfirmedDispensation */.A1.ConfirmedDispensation:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.ConfirmedDispensation */.aT.ConfirmedDispensation;
        case gql_schema/* PharmacyFilterType.DispensationProbability */.A1.DispensationProbability:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.DispensationProbability */.aT.DispensationProbability;
        case gql_schema/* PharmacyFilterType.HandlingMedicine */.A1.HandlingMedicine:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.HandlingMedicine */.aT.HandlingMedicine;
        case gql_schema/* PharmacyFilterType.HighDispensationProbability */.A1.HighDispensationProbability:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.HighDispensationProbability */.aT.HighDispensationProbability;
        case gql_schema/* PharmacyFilterType.IncludeDiagnosisPrice */.A1.IncludeDiagnosisPrice:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.IncludeDiagnosisPrice */.aT.IncludeDiagnosisPrice;
        case gql_schema/* PharmacyFilterType.IsOpenAtLateNight */.A1.IsOpenAtLateNight:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.IsOpenAtLateNight */.aT.IsOpenAtLateNight;
        case gql_schema/* PharmacyFilterType.IsOpenEveryDay */.A1.IsOpenEveryDay:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.IsOpenEveryDay */.aT.IsOpenEveryDay;
        case gql_schema/* PharmacyFilterType.Now */.A1.Now:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.Now */.aT.Now;
        case gql_schema/* PharmacyFilterType.Operating */.A1.Operating:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.Operating */.aT.Operating;
        case gql_schema/* PharmacyFilterType.PossibleDispensation */.A1.PossibleDispensation:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.PossibleDispensation */.aT.PossibleDispensation;
        case gql_schema/* PharmacyFilterType.RequestWithApp */.A1.RequestWithApp:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.RequestWithApp */.aT.RequestWithApp;
        case gql_schema/* PharmacyFilterType.SameMedicine */.A1.SameMedicine:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.SameMedicine */.aT.SameMedicine;
        // FavoritePharmacy, Partnership, TreatmentMedicine는 없으므로 기본값 반환
        default:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.CheapPrice */.aT.CheapPrice;
    }
};
var mapToPharmacySortsVo = function(sort) {
    // PharmacySortType을 ENearbyPharmacySearchSortType으로 매핑
    var sortType;
    switch(sort.type){
        case gql_schema/* PharmacySortType.Distance */.f$.Distance:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.Distance */.sZ.Distance;
            break;
        case gql_schema/* PharmacySortType.LowPrice */.f$.LowPrice:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.LowPrice */.sZ.LowPrice;
            break;
        case gql_schema/* PharmacySortType.QuickReceipt */.f$.QuickReceipt:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.QuickReceipt */.sZ.QuickReceipt;
            break;
        case gql_schema/* PharmacySortType.VisitCount */.f$.VisitCount:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.VisitCount */.sZ.VisitCount;
            break;
        case gql_schema/* PharmacySortType.MostReviews */.f$.MostReviews:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.MostReviews */.sZ.MostReviews;
            break;
        case gql_schema/* PharmacySortType.HighRating */.f$.HighRating:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.HighRating */.sZ.HighRating;
            break;
        // DispensationProbability는 ENearbyPharmacySearchSortType에 없음 -> 기본값 사용
        default:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.QuickReceipt */.sZ.QuickReceipt;
    }
    return {
        title: sort.title,
        type: sortType
    };
};
var parseNonBenefitMapNearByPharmacySearchTabsVo = function(data) {
    return data.nonBenefitMapNearbyPharmacySearchTabs.map(function(item) {
        return {
            id: item.id,
            name: item.name,
            diagnosisType: item.diagnosisType,
            diagnosisTypeId: item.diagnosisTypeId,
            filters: item.filters.map(function(filter) {
                var _activeIconUrl, _inactiveIconUrl, _title, _description;
                return new models_pharmacy/* NearbyPharmacyFilterModel */.QJ({
                    activeIconUrl: (_activeIconUrl = filter.activeIconUrl) !== null && _activeIconUrl !== void 0 ? _activeIconUrl : undefined,
                    inactiveIconUrl: (_inactiveIconUrl = filter.inactiveIconUrl) !== null && _inactiveIconUrl !== void 0 ? _inactiveIconUrl : undefined,
                    mode: mapToPharmacyFilterMode(filter.mode),
                    title: (_title = filter.title) !== null && _title !== void 0 ? _title : "",
                    description: (_description = filter.description) !== null && _description !== void 0 ? _description : "",
                    type: mapToPharmacySearchFilterType(filter.type),
                    subFilters: filter.subFilters.map(function(subFilter) {
                        var _title, _description;
                        return new models_pharmacy/* NearbyPharmacyFilterModel */.QJ({
                            mode: mapToPharmacyFilterMode(subFilter.mode),
                            title: (_title = subFilter.title) !== null && _title !== void 0 ? _title : "",
                            description: (_description = subFilter.description) !== null && _description !== void 0 ? _description : "",
                            type: mapToPharmacySearchFilterType(subFilter.type),
                            subFilters: []
                        });
                    })
                });
            }),
            sortTypes: item.sortTypes.map(function(type) {
                return mapToPharmacySortsVo(type);
            })
        };
    });
};
var useNonBenefitMapNearByPharmacySearchTabs = function() {
    var data = (0,nonBenefit_gql_impl/* useNonBenefitMapNearbyPharmacySearchTabsQuery */.Y1)({}, {
        select: parseNonBenefitMapNearByPharmacySearchTabsVo,
        staleTime: 1000 * 60 * 5
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ var useNonBenefitMapNearbyPharmacySearchTabs = (useNonBenefitMapNearByPharmacySearchTabs);
var prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(nonBenefit_gql_impl/* useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey */.Y1.getKey({}), nonBenefit_gql_impl/* useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher */.Y1.fetcher({}))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function prefetchQuery(queryClient) {
        return _ref.apply(this, arguments);
    };
}();
useNonBenefitMapNearByPharmacySearchTabs.prefetchQuery = prefetchQuery;

;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitMapCategoryTabs.ts






var useNonBenefitMapCategoryTabs = function() {
    var router = (0,next_router.useRouter)();
    var diagnosisTypeId = router.query.diagnosisTypeId;
    var ref = useNonBenefitMapNearbyPharmacySearchTabs(), tabs = ref.data;
    var ref1 = (0,react.useState)(null), selectedTab = ref1[0], setSelectedTab = ref1[1];
    var log = (0,useLogger/* default */.Z)().log;
    var selectTab = function(tab) {
        setSelectedTab(tab);
        var _diagnosisType, _diagnosisTypeId;
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: "diagnosisType",
                value: (_diagnosisType = tab.diagnosisType) !== null && _diagnosisType !== void 0 ? _diagnosisType : ""
            },
            {
                key: "diagnosisTypeId",
                value: (_diagnosisTypeId = tab.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : ""
            },
            {
                key: "treatmentMedicineId",
                value: ""
            },
            {
                key: "treatmentMedicineUnitId",
                value: ""
            }, 
        ]);
        log({
            eventName: "".concat(pharmacy/* FindPharmacyDdAction.ClickTab */.vy.ClickTab, "-").concat(tab.id)
        });
    };
    (0,react.useEffect)(function() {
        if (!tabs) {
            return;
        }
        if (diagnosisTypeId) {
            var selectedTab = tabs.find(function(tab) {
                return tab.diagnosisTypeId === diagnosisTypeId;
            });
            if (selectedTab) {
                setSelectedTab(selectedTab);
                return;
            }
        }
        setSelectedTab(tabs === null || tabs === void 0 ? void 0 : tabs[0]);
    }, [
        tabs,
        diagnosisTypeId
    ]);
    return {
        tabs: tabs,
        selectedTab: selectedTab,
        selectTab: selectTab
    };
};
/* harmony default export */ var nonBenefit_useNonBenefitMapCategoryTabs = (useNonBenefitMapCategoryTabs);

;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitMapViewModel.tsx

































var airbrigdeLink = "https://abr.ge/w3tbbv";
var useNonBenefitMapViewModel = function(client) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var router = (0,next_router.useRouter)();
    var queries = router.query;
    var treatmentMedicineId = queries.treatmentMedicineId;
    var ref9 = nonBenefit_useNonBenefitMapCategoryTabs(), tabs = ref9.tabs, selectedTab = ref9.selectedTab, selectTab = ref9.selectTab;
    var mapRef = (0,react.useRef)(null);
    var pharmacyListBottomSheetRef = (0,react.useRef)(null);
    var ref10 = (0,useModal/* default */.Z)(), showModal = ref10.showModal, closeModal = ref10.closeModal;
    var breadCrumbs = [
        {
            label: "최저가 약국 찾기",
            url: common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path + (0,utils_url/* addQueryString */.sC)(queries),
            logName: "non_benefit_map"
        }, 
    ];
    var scrollListRef = (0,react.useRef)(null);
    var userLocationHook = common_useWebLocation();
    var ref11 = (0,react.useState)(null), selectedPharmacy = ref11[0], setSelectedPharmacy = ref11[1];
    var ref12 = (0,react.useState)(null), pharmacyMapInitiateError = ref12[0], setPharmacyMapInitiateError = ref12[1];
    var ref13 = (0,react.useState)(null), pharmacyFilterCriteria = ref13[0], setPharmacyFilterCriteria = ref13[1];
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var addFavoritePharmacyMutation = (0,useAddFavoritePharmacy/* default */.Z)().addFavoritePharmacyMutation;
    var removeFavoritePharmacyMutation = (0,useRemoveFavoritePharmacy/* default */.Z)().removeFavoritePharmacyMutation;
    var showToast = (0,useToaster/* default */.Z)().showToast;
    var log = (0,useLogger/* default */.Z)().log;
    var loginViewModel = (0,useLoginViewModel/* default */.Z)();
    var ref14 = (0,react.useState)(false), showLoginModal = ref14[0], setShowLoginModal = ref14[1];
    var openLoginModal = function() {
        setShowLoginModal(true);
    };
    var closeLoginModal = function() {
        setShowLoginModal(false);
    };
    var shouldShowPharmacyCard = !!selectedPharmacy;
    var updateSelectedPharmacy = function(pharmacy) {
        setSelectedPharmacy(pharmacy);
        if (pharmacyListBottomSheetRef.current) {
            var ref;
            (ref = pharmacyListBottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.setInitialSnapPoint();
        }
    };
    var resetSelectedPharmacy = function() {
        setSelectedPharmacy(null);
        if (pharmacyListBottomSheetRef.current) {
            var ref;
            (ref = pharmacyListBottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.setInitialSnapPoint();
        }
    };
    var updatePharmacyMapInitiateError = function(error) {
        setPharmacyMapInitiateError(error);
    };
    var pharmacyViewTypeHook = hooks_usePharmacyViewType();
    var selectedTreatmentMedicine = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedMedicine;
    var ref15, ref16, _type;
    var searchFiltersHook = (0,usePharmacySearchFilters/* default */.Z)({
        nearbyPharmacySortsAndFilters: {
            filters: (ref15 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref = pharmacyFilterCriteria.selectedTab) === null || ref === void 0 ? void 0 : ref.filters) !== null && ref15 !== void 0 ? ref15 : [],
            sorts: (ref16 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref1 = pharmacyFilterCriteria.selectedTab) === null || ref1 === void 0 ? void 0 : ref1.sortTypes) !== null && ref16 !== void 0 ? ref16 : []
        },
        defaultSortType: (_type = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref2 = pharmacyFilterCriteria.selectedTab) === null || ref2 === void 0 ? void 0 : ref2.sortTypes[0].type) !== null && _type !== void 0 ? _type : types_pharmacy/* ENearbyPharmacySearchSortType.LowPrice */.sZ.LowPrice
    });
    var ref17, ref18;
    var ref19 = (0,useFindGeneralListOfNearbyPharmacyV3ByUser/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchFiltersHook.getBoundaryEastWestLongitudeAndLatitude(!!pharmacyMapInitiateError)), {
        latitude: searchFiltersHook.mapCoordinates.latitude,
        longitude: searchFiltersHook.mapCoordinates.longitude,
        diagnosisType: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref3 = pharmacyFilterCriteria.selectedTab) === null || ref3 === void 0 ? void 0 : ref3.diagnosisType,
        diagnosisTypeId: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref4 = pharmacyFilterCriteria.selectedTab) === null || ref4 === void 0 ? void 0 : ref4.diagnosisTypeId,
        treatmentMedicineId: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref5 = pharmacyFilterCriteria.selectedMedicine) === null || ref5 === void 0 ? void 0 : ref5.treatmentMedicine.treatmentMedicineId,
        dispensationUnit: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref6 = pharmacyFilterCriteria.selectedMedicine) === null || ref6 === void 0 ? void 0 : ref6.dispensationUnit.dispensationUnit,
        shouldIncludeDiagnosisPrice: (ref18 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref7 = pharmacyFilterCriteria.includeDiagnosisPriceFilter) === null || ref7 === void 0 ? void 0 : ref7.isSelectedFilter((ref17 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedCommonFilters) !== null && ref17 !== void 0 ? ref17 : [])) !== null && ref18 !== void 0 ? ref18 : false
    })), rawPharmacyList = ref19.data, isNearbyPharmaciesLoading = ref19.isLoading;
    var ref20;
    var ref21 = (0,useFilteredAndSortedPharmacy/* default */.Z)({
        filters: (ref20 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedCommonFilters) !== null && ref20 !== void 0 ? ref20 : [],
        sortType: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedSortMethod.type,
        rawPharmacyData: rawPharmacyList !== null && rawPharmacyList !== void 0 ? rawPharmacyList : [],
        shouldFilterByPriceMedicine: !!(pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref8 = pharmacyFilterCriteria.selectedMedicine) === null || ref8 === void 0 ? void 0 : ref8.treatmentMedicine.treatmentMedicineId)
    }), pharmacies = ref21.refinedPharmacy;
    var shouldShowEmptyPharmacyMessage = function() {
        if (isNearbyPharmaciesLoading || pharmacies.length) {
            return false;
        }
        if (pharmacies.length === 0) {
            return true;
        }
        return false;
    };
    var parseSelectNonBenefitMedicine = function() {
        var ref, ref1, ref2;
        var ref3;
        var defaultValue = {
            // 선택된 약 아이디가 없으면 서버사이드 props로 내려온 쿼리값으로 초기화
            id: (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref = pharmacyFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.treatmentMedicineId) || treatmentMedicineId || "",
            medicineName: (ref3 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref1 = pharmacyFilterCriteria.selectedMedicine) === null || ref1 === void 0 ? void 0 : ref1.medicineDisplayName()) !== null && ref3 !== void 0 ? ref3 : "",
            medicineDescription: "",
            // 사실상 사용하는곳 없음, 일단 NonBenefitMedicine 타입에 맞게 넣어둠, 서버에서도 모두 true로 내려옴, 추후 삭제해도 될듯
            units: [],
            treatment: {
                // 처음에는 선택된 탭에 있는 진료 아이디로 주고, 선택된 약 아이디가 없으면 서버사이드 props로 내려온 쿼리값으로 초기화
                id: (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref2 = pharmacyFilterCriteria.selectedTab) === null || ref2 === void 0 ? void 0 : ref2.diagnosisTypeId) || treatmentMedicineId || "",
                // NonBenefitMedicine 클래스에 name 사용하는 부분 없어서 빈값으로 고정, 추후 삭제해도 될듯
                name: "",
                isBenefit: false,
                // 사용하는곳 없음, 추후 삭제해도 될듯
                categoryId: ""
            }
        };
        return new nonBenefit/* NonBenefitMedicine */.Vp(defaultValue);
    };
    var onClickViewListModeButtonWithResetSelectedPharmacy = function() {
        var ref;
        resetSelectedPharmacy();
        (ref = pharmacyListBottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.clickViewListModeButton();
    };
    var selectedMedicine = parseSelectNonBenefitMedicine();
    var onClickPharmacyItem = function(selectPharmacy) {
        if (pharmacyMapInitiateError) {
            return;
        }
        setSelectedPharmacy(selectPharmacy);
    };
    var scrollToTop = function() {
        var ref;
        (ref = scrollListRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            top: 0
        });
    };
    var applyFilter = function(filterCriteria) {
        scrollToTop();
        setPharmacyFilterCriteria(filterCriteria);
    };
    var isSelectedLowPrice = !!(pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedMedicine);
    var ref22 = (0,react.useState)({
        latitude: map/* DOCTOR_NOW_COMPANY_LATITUDE */.q,
        longitude: map/* DOCTOR_NOW_COMPANY_LONGITUDE */.y
    }), currentMapLocation = ref22[0], setCurrentMapLocation = ref22[1];
    var updateCurrentMapCoordinate = function(southWest, northEast) {
        var ref;
        searchFiltersHook.updateMapCoordinate(southWest, northEast);
        var mapCenterLatLng = (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.getCenterLatLng();
        var latitude = mapCenterLatLng === null || mapCenterLatLng === void 0 ? void 0 : mapCenterLatLng.latitude;
        var longitude = mapCenterLatLng === null || mapCenterLatLng === void 0 ? void 0 : mapCenterLatLng.longitude;
        if (!latitude || !longitude) {
            return;
        }
        setCurrentMapLocation({
            latitude: latitude,
            longitude: longitude
        });
    };
    var isSelectedAllTab = function() {
        var ref, ref1, ref2;
        // 전체 탭의 세부 정보 (서버에서 내려옴)
        var ALL_TAB_INFO = {
            name: "전체",
            diagnosisTypeId: null,
            diagnosisType: null
        };
        var isSameDiagnosisTypeWithAllTab = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref = pharmacyFilterCriteria.selectedTab) === null || ref === void 0 ? void 0 : ref.diagnosisType) === ALL_TAB_INFO.diagnosisType;
        var isSameDiagnosisTypeIdWithAllTab = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref1 = pharmacyFilterCriteria.selectedTab) === null || ref1 === void 0 ? void 0 : ref1.diagnosisTypeId) === ALL_TAB_INFO.diagnosisTypeId;
        var isSameNameWithAllTab = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref2 = pharmacyFilterCriteria.selectedTab) === null || ref2 === void 0 ? void 0 : ref2.name) === ALL_TAB_INFO.name;
        var ref3;
        return (ref3 = isSameDiagnosisTypeWithAllTab && isSameDiagnosisTypeIdWithAllTab && isSameNameWithAllTab) !== null && ref3 !== void 0 ? ref3 : false;
    };
    var getFavoritePharmacyClickEventName = function(isFavorite) {
        var viewType = pharmacyViewTypeHook.shouldShowListView ? "list" : "map";
        if (isFavorite) {
            return "".concat(pharmacy/* PharmacyDdAction.ClickRemoveFavoritePharmacy */.Fe.ClickRemoveFavoritePharmacy, "_find_").concat(viewType);
        }
        return "".concat(pharmacy/* PharmacyDdAction.ClickAddFavoritePharmacy */.Fe.ClickAddFavoritePharmacy, "_find_").concat(viewType);
    };
    var onClickOpenAppInstallLink = function() {
        airbridge/* default.setDeepLink */.Z.setDeepLink({
            buttonID: "pharmacy-map",
            deeplinkUrl: airbrigdeLink,
            ctaParams: {
                cta_param_1: "최저가 약국 지도",
                cta_param_2: selectedMedicine.medicineName,
                cta_param_3: selectedMedicine.treatment.name
            }
        });
    };
    var onOpenAppInstallBottomSheet = function() {
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosisAppInstallBottomSheet/* default */.Z, {
                    client: client,
                    buttonId: "pharmacy-map",
                    title: "닥터나우 앱을 설치하면\n".concat(selectedMedicine.treatmentProductMedicineName, " 처방이 가능해요!"),
                    description: "QR 코드를 스캔하면 앱을 설치할 수 있습니다",
                    onClose: closeModal,
                    qrCodeUrl: airbrigdeLink,
                    onClickOpenAppInstallLink: onClickOpenAppInstallLink
                })
            }
        });
    };
    var onClickTab = function(tab) {
        selectTab(tab);
        resetSelectedPharmacy();
    };
    var addFavoritePharmacy = function(pharmacy) {
        addFavoritePharmacyMutation({
            pharmacyId: pharmacy.pharmacyId
        }, {
            onSuccess: function() {
                showToast("단골 약국으로 지정했어요.\n더보기 메뉴에서 확인할 수 있어요.");
                pharmacy.updateFavoritePharmacy(true);
                // 단골 약국 캐시 업데이트
                useFavoritePharmacies/* default.updateFavoritePharmacyStatus */.Z.updateFavoritePharmacyStatus(queryClient, pharmacy.pharmacyId, true);
            },
            onError: function(error) {
                showToast(error.message);
            }
        });
    };
    var removeFavoritePharmacy = function(pharmacy) {
        removeFavoritePharmacyMutation({
            pharmacyId: pharmacy.pharmacyId
        }, {
            onSuccess: function() {
                showToast("단골 약국에서 제외했어요.");
                pharmacy.updateFavoritePharmacy(false);
                // 단골 약국 캐시 업데이트
                useFavoritePharmacies/* default.updateFavoritePharmacyStatus */.Z.updateFavoritePharmacyStatus(queryClient, pharmacy.pharmacyId, false);
            }
        });
    };
    var onClickFavoritePharmacy = function(e, pharmacy) {
        e.stopPropagation();
        if (!(client === null || client === void 0 ? void 0 : client.isWebView) && !loginViewModel.isLoggedIn) {
            openLoginModal();
            return;
        }
        if (pharmacy.isFavoritePharmacy) {
            return removeFavoritePharmacy(pharmacy);
        }
        addFavoritePharmacy(pharmacy);
    };
    var openNowPharmacyInfo = function() {
        log({
            eventName: "".concat(pharmacy/* FindPharmacyDdAction.ClickNowInfoInFind */.vy.ClickNowInfoInFind)
        });
        (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
            screenName: "PureWebViewScreen",
            params: {
                uri: url/* OutLinks.NowPharmacyInfo */.s.NowPharmacyInfo,
                headerTitle: ""
            }
        });
    };
    var onClickCurrentLocation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // useWebLocation을 이용한 구현
                userLocationHook.requestGeolocationPermissionInWeb(function(param) {
                    var latitude = param.latitude, longitude = param.longitude;
                    var ref;
                    if (pharmacyMapInitiateError) {
                        return;
                    }
                    (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.setCenter(latitude, longitude);
                }, true);
                return [
                    2
                ];
            });
        });
        return function onClickCurrentLocation() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref23;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        breadCrumbs: breadCrumbs
    }, userLocationHook, searchFiltersHook), {
        isNearbyPharmaciesLoading: isNearbyPharmaciesLoading,
        pharmacies: pharmacies,
        scrollListRef: scrollListRef,
        selectedTreatmentMedicine: selectedTreatmentMedicine,
        isSelectedLowPrice: isSelectedLowPrice,
        queries: queries,
        selectedMedicine: selectedMedicine,
        currentMapLocation: currentMapLocation,
        selectedPharmacy: selectedPharmacy,
        mapRef: mapRef,
        pharmacyListBottomSheetRef: pharmacyListBottomSheetRef,
        tabs: tabs,
        selectedTab: selectedTab,
        selectedTabName: (ref23 = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.name) !== null && ref23 !== void 0 ? ref23 : "탈모약",
        shouldShowPharmacyCard: shouldShowPharmacyCard,
        selectTab: selectTab,
        onClickTab: onClickTab,
        shouldShowEmptyPharmacyMessage: shouldShowEmptyPharmacyMessage,
        updateCurrentMapCoordinate: updateCurrentMapCoordinate,
        applyFilter: applyFilter,
        updateSelectedPharmacy: updateSelectedPharmacy,
        resetSelectedPharmacy: resetSelectedPharmacy,
        updatePharmacyMapInitiateError: updatePharmacyMapInitiateError,
        onClickPharmacyItem: onClickPharmacyItem,
        isSelectedAllTab: isSelectedAllTab,
        onOpenAppInstallBottomSheet: onOpenAppInstallBottomSheet,
        getFavoritePharmacyClickEventName: getFavoritePharmacyClickEventName,
        onClickViewListModeButtonWithResetSelectedPharmacy: onClickViewListModeButtonWithResetSelectedPharmacy,
        openNowPharmacyInfo: openNowPharmacyInfo,
        onClickFavoritePharmacy: onClickFavoritePharmacy,
        openLoginModal: openLoginModal,
        closeLoginModal: closeLoginModal,
        showLoginModal: showLoginModal,
        onClickCurrentLocation: onClickCurrentLocation
    });
};
/* harmony default export */ var nonBenefit_useNonBenefitMapViewModel = (useNonBenefitMapViewModel);

;// CONCATENATED MODULE: ./src/pages/non-benefit/map/index.tsx
// PageDescription: 비급여 가격 지도 페이지







var NonBenefitMapPages = function(param) {
    var client = param.client;
    var ref;
    var viewModel = nonBenefit_useNonBenefitMapViewModel(client);
    var _queries = viewModel.queries, treatmentMedicineId = _queries.treatmentMedicineId, diagnosisTypeId = _queries.diagnosisTypeId;
    var selectedMedicine = viewModel.selectedMedicine;
    var ref1, ref2;
    var title = "".concat((ref1 = selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.treatmentProductMedicineName) !== null && ref1 !== void 0 ? ref1 : "", " 최저가 약국 찾기 ").concat((ref2 = selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.medicineName) !== null && ref2 !== void 0 ? ref2 : "", " 2025");
    var ref3, ref4;
    var description = "내 근처 약국의 ".concat((ref3 = selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.treatmentProductMedicineName) !== null && ref3 !== void 0 ? ref3 : "", " ").concat((ref4 = selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.medicineName) !== null && ref4 !== void 0 ? ref4 : "", " 가격을 지도에서 비교할 수 있어요 - ").concat(selectedMedicine.medicineProductName);
    var canonical = "".concat("https://doctornow.co.kr").concat(common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path).concat((0,utils_url/* addQueryString */.sC)({
        diagnosisTypeId: diagnosisTypeId,
        treatmentMedicineId: ((ref = viewModel.selectedTreatmentMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.treatmentMedicineId) || treatmentMedicineId
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                canonical: canonical,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-main.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(map_NonBenefitMapTemplate, {
                client: client,
                viewModel: viewModel,
                title: "".concat(selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.treatmentProductMedicineName, " 최저가 약국 찾기")
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var non_benefit_map = (NonBenefitMapPages);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2182,1498,1093,7096,2890,4329,6562,6870,9004,3663,5203,8185,7757,7690,5442,9691,6318,9892,9287,1665,3018,9107,3155,9774,2888,179], function() { return __webpack_exec__(19494); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);